export const BelgianEnterpriseNumber = /^[0-9]{10}$/
export const Email =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const LettersNumbersSlashesAndDashes = /^[a-zA-Z0-9/-]*$/
export const ZeroOrPositiveNumbersWithNoDecimals = /^[0-9]\d*$/
export const PostalCode = /[0-9]{4}/
export const NON_BE_PHONE = /^[+]?[0-9]{2}?[0-9]{7,12}$/
export const BE_PHONE = /^[+]?[0-9]{2}?[0-9]{7,9}$/
